const plugin = require("tailwindcss/plugin");

const backfaceVisibility = plugin(function ({ addUtilities }) {
	addUtilities({
		".backface-visible": {
			"backface-visibility": "visible",
		},
		".backface-hidden": {
			"backface-visibility": "hidden",
		},
	});
});

module.exports = {
	content: [
		//'./**/*.php', // recursive search for *.php (be aware on every file change it will go even through /node_modules which can be slow, read doc)
		//'./src/styles/safelist.txt' // Use in case the inline "safelist" gets too long
		"./*.php",
		"./lib/**/*.php",
		"./templates/**/*.php",
		"./search-filter/**/*.php",
		"./src/js/twk-custom-tinymce-dialog.js",
	],
	safelist: [
		"text-52pl",
		"bg-blue/20",
		"bg-pink/20",
		"bg-lime-green/20",
		"border-white/10",
		"columns-2",
		"children:fill-white",
		"children:fill-dark-navy",
		"w-200",
		"children:w-200",
		"lg:mt-40",
		"lg:mt-80",
		"lg:mt-120",
		"group-hover:bg-white",
		"group-hover:bg-dark-navy",
		{
			pattern: /bg-(blue|pink|lime-green)/,
			pattern: /text-(blue|pink|lime-green)/,
		},
	],
	theme: {
		colors: {
			transparent: "transparent",
			white: "#fff",
			black: "#000",
			"dark-navy": "#002B3D",
			blue: "#007EB5",
			"lime-green": "#A7D643",
			pink: "#C520A5",
			"citation-text": "#979797",
			"footer-link-blue": "#0094D5",
			"darker-navy": "#000E35",
			"lime-green-tint": "#F6FBEC",
			"blue-tint": "#E5F4FB",
			"pink-tint": "#F9E9F6",
			"pure-white": "#FFFFFF",
			"light-grey": "#F8F8F8",
			grey: "#4A6972",
			"blue-20": "#CCD5D8",
			"blue-hover": "#006490",
			"lime-green-hover": "#83A932",
			"pink-hover": "#85176F",
		},
		fontFamily: {
			dmsans: ["DM Sans", "sans-serif"],
			rollerscript: ["Rollerscript", "cursive"],
			ppfragment: ["PPFragment", "serif"],
		},
		/* fontSize: {
            '30': ['30px'],
            '48': ['48px'],
        }, */
		/* lineHeight: {
            '30': '30px',
            '40': '40px',
        }, */
		/* letterSpacing: {
            tighter: '-0.5px',
            tight: '-0.25px',
            normal: 'normal',
            wide: '-0.1px',
            wider: '-0.07px',
            widest: '1px',
        }, */
		borderRadius: {
			none: "0px",
			2: "2px",
			4: "4px",
			5: "5px",
			6: "6px",
			8: "8px",
			10: "10px",
			12: "12px",
			14: "14px",
			15: "15px",
			20: "20px",
			25: "25px",
			30: "30px",
			35: "35px",
			40: "40px",
			45: "45px",
			50: "50px",
			full: "9999px",
		},
		spacing: {
			0: "0px",
			1: "1px",
			2: "2px",
			3: "3px",
			4: "4px",
			5: "5px",
			6: "6px",
			7: "7px",
			8: "8px",
			9: "9px",
			10: "10px",
			12: "12px",
			15: "15px",
			18: "18px",
			16: "16px",
			20: "20px",
			24: "24px",
			25: "25px",
			28: "28px",
			30: "30px",
			35: "35px",
			40: "40px",
			45: "45px",
			50: "50px",
			55: "55px",
			60: "60px",
			65: "65px",
			70: "70px",
			75: "75px",
			80: "80px",
			85: "85px",
			90: "90px",
			95: "95px",
			100: "100px",
			105: "105px",
			110: "110px",
			115: "115px",
			120: "120px",
			125: "125px",
			130: "130px",
			135: "135px",
			140: "140px",
			145: "145px",
			150: "150px",
			160: "160px",
			170: "170px",
			180: "180px",
			190: "190px",
			200: "200px",
			300: "300px",
			400: "400px",
			500: "500px",
		},
		container: {
			center: true,
			padding: {
				// Need to assign all of the screen sizes or the container-break-out plugin won't work
				DEFAULT: "40px",
				xs: "40px",
				sm: "40px",
				md: "40px",
				lg: "40px",
				xl: "40px",
				"2xl": "40px",
			},
			screens: {
				xs: "340px",
				sm: "576px",
				md: "768px",
				lg: "992px",
				"2lg": "1116px",
				xl: "1380px",
				"2xl": "1536px",
			},
		},
		screens: {
			"2xs": "340px",
			xs: "390px",
			sm: "576px",
			md: "768px",
			lg: "992px",
			"2lg": "1116px",

			xl: "1380px",
			"2xl": "1536px",
			letter: { raw: "(max-height: 750px) and (min-width: 900px)" },
		},
		extend: {
			container: {
				screens: {
					xs: {
						max: "none", // Remove the max-width: 340px from the xs breakpoint
					},
					sm: {
						max: "none", // Remove the max-width: 340px from the xs breakpoint
					},
				},
			},
			typography: (theme) => ({
				DEFAULT: {
					css: {
						"*": {
							"&:first-child": {
								marginTop: 0,
							},
							"&:last-child:not(img):not(picture)": {
								marginBottom: 0,
							},
							"&:last-child:not(img):not(picture) img": {
								marginBottom: 0,
							},
						},
					},
				},
			}),
			debugScreens: {
				position: ["bottom", "left"],
			},
		},
	},
	plugins: [
		backfaceVisibility,
		function ({ addVariant }) {
			addVariant("children", "& > *");
			addVariant("children-all", "& *");
			//addVariant("next-peer-hover", ".peer:hover + &");
			//addVariant("item-active", "&[data-active=true]");
			//addVariant("item-active-children", "&[data-active=true] > *");
		},
		// require("@tailwindcss/typography"),
		require("@tailwindcss/forms"),
		require("tailwindcss-debug-screens"),
		require("tailwind-container-break-out"),
	],
};
